(function(EF) {

  var ActionPlanItem = Chaplin.Model.extend({});

  _.extend(EF.Models, {
    ActionPlanItem: ActionPlanItem
  });

}(EF));
